import ReferralUser from '@components/widgets/referral-user/referral-user';
export default ReferralUser;
